import {createApp} from 'vue'
import App from './App.vue'
import './css/main.css'
import './css/animate.css'

createApp(App).mount('#app')
